import React, { FC } from "react";
import { getFalconColorsClass } from "../../utils/utils";
import { H1, H2, H3, H4, NONE } from "../../utils/constants";
import "./FalconTitle.css";
import {
  GenericSBProps,
  HeadingVariants,
  FalconColorsTypes,
  NativeColorPicker,
  ComponentWithContentProps,
} from "./../types";

export interface FalconTitleInterface extends GenericSBProps {
  text: string;
  headingStyle: HeadingVariants;
  textColor: FalconColorsTypes;
  textColorPicker: NativeColorPicker;
}
const FalconTitle: FC<ComponentWithContentProps<FalconTitleInterface>> = ({
  content,
}) => {
  const titleStyle = getFalconColorsClass(
    content?.textColor && content.textColor
  );
  const titleClassname =
    content?.textColor && content.textColor != NONE ? titleStyle : "";
  const titleColor =
    content?.textColor && content.textColor === NONE
      ? { color: content.textColorPicker?.color }
      : {};
  return (
    <>
      {content.headingStyle && content.text && content.headingStyle === H1 ? (
        <h1
          className={titleClassname}
          style={{
            ...titleColor,
          }}
        >
          {content.text}{" "}
        </h1>
      ) : content.headingStyle === H2 ? (
        <h2
          className={`${titleClassname}`}
          style={{
            ...titleColor,
          }}
        >
          {content.text}
        </h2>
      ) : content.headingStyle === H3 ? (
        <h3
          className={titleClassname}
          style={{
            ...titleColor,
          }}
        >
          {content.text}
        </h3>
      ) : content.headingStyle === H4 ? (
        <h4
          className={titleClassname}
          style={{
            ...titleColor,
          }}
        >
          {content.text}
        </h4>
      ) : (
        <div
          className="dbold"
          style={{
            ...titleColor,
          }}
        >
          {content.text}
        </div>
      )}
    </>
  );
};

export default FalconTitle;
